import Box from '@mui/material/Box';
import useCfop from '../../../../hooks/useCfop';
import { BoxButtons, Button } from '../../../Styles/ScreenStyle';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import TextField from '@mui/material/TextField';
import { Form, Formik, Field } from 'formik';
import * as Icon from '@mui/icons-material/';
import { InputSelect } from '../../../../shared/components/InputSelect';

import CfopController from '../../../../controllers/CfopController';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useParams, useLocation } from 'react-router-dom';

export default function CfopCadastrar() {
  const [single, setSingle] = useState<any>(null);

  const itemsTipo = [
    { value: 'T', label: 'Todos' },
    { value: 'E', label: 'Entrada' },
    { value: 'S', label: 'Saída' },
  ];

  const itemsVenda = [
    { value: 'S', label: 'Sim' },
    { value: 'N', label: 'Não' },
  ];
  const { id } = useParams();
  const Codigo = id ? parseInt(id, 10) : null;
  const location = useLocation();
  const duploClick = location.state?.duploClick || false;

  useEffect(() => {
    if (Codigo !== null && Codigo !== undefined) {
      getSingle(Codigo);
    }
  }, [Codigo]);

  const getSingle = async (Codigo: number) => {
    const Response = await CfopController.ListarUnico(Codigo);
    setSingle(Response.Data);
  };

  const initialValues = {
    Cfop_Id: single?.cfo_id || '',
    Cfop_Descricao: single?.cfo_descricao || '',
    Cfop_Tipo: single?.cfo_tipo || '',
    Cfop_Venda: single?.cfo_venda || '',
  };

  const handleSubmit = async (
    values: any,
    { setSubmitting, resetForm }: any
  ) => {
    if (Codigo === null) {
      const response = await CfopController.Gravar(values);
      if (response.StatusCode === 204 || response.StatusCode === 200) {
        toast('CFOP incluido com sucesso!', {
          type: 'success',
        })
        resetForm();
      } else {
        toast('Erro ao incluir o CFOP!', {
          type: 'error',
        })
        resetForm();
      }
    } else {
      EditarContato(values, { setSubmitting, resetForm });
    }

    setSubmitting(false);
  };

  const EditarContato = async (
    values: any,
    { setSubmitting }: any
  ) => {
    const request = {
      Cfop_Id: Codigo,
      ...values,
    };

    const response = await CfopController.Atualizar(request);

    if (response.StatusCode === 204 || response.StatusCode === 200) {
      toast('CFOP atualizado com sucesso!', {
        type: 'success',
      })
    } else {
      toast('Erro ao atualizar o CFOP!', {
        type: 'error',
      })
    }

    setSubmitting(false);
  };

  const { errors, touched, handleChange, backActions } = useCfop();

  return (
    <Box
      sx={{
        '& .MuiTextField-root': { m: 1, width: '35ch' },
      }}
    >
      <HeaderComponent text={'CADASTRO CFOP'} className={'mb-5'} />

      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue }) => (
          <Form>
            <BoxButtons>
              <Button
                variant='contained'
                onClick={() => backActions()}
                color='warning'
                startIcon={<Icon.ArrowBack />}
              >
                Voltar
              </Button>
              <Button
                type={'submit'}
                variant='contained'
                color='success'
                startIcon={<Icon.Save />}
                disabled={duploClick}
              >
                Salvar
              </Button>
            </BoxButtons>
            <fieldset disabled={duploClick}>
            <Field
              label='Código'
              name='Cfop_Id'
              as={TextField}
              placeholder=''
              type='number'
              error={touched.Cfop_Id && errors?.Cfop_Id ? errors.Cfop_Id : ''}
              helperText={touched.Cfop_Id && errors?.Cfop_Id}
            />
            <Field
              label='Descricao'
              name='Cfop_Descricao'
              as={TextField}
              placeholder=''
              type='text'
              handleChange={handleChange}
              error={
                touched.Cfop_Descricao && errors.Cfop_Descricao
                  ? errors.Cfop_Descricao
                  : ''
              }
              helperText={touched.Cfop_Descricao && errors?.Cfop_Descricao}
            />
            <Field
              name='Cfop_Tipo'
              as={InputSelect}
              className='col-span-2'
              label='Tipo'
              type='text'
              items={itemsTipo}
              disabled={duploClick}
              handleChange={(event: any) => {
                const { value } = event.target;
                setFieldValue('Cfop_Tipo', value);
              }}
              error={Boolean(errors?.Cfop_Tipo)}
              helperText={errors?.Cfop_Tipo}              
            />
            <Field
              name='Cfop_Venda'
              as={InputSelect}
              className='col-span-2'
              label='Venda'
              type='text'
              items={itemsVenda}
              disabled={duploClick}
              handleChange={(event: any) => {
                const { value } = event.target;
                setFieldValue('Cfop_Venda', value);
              }}
              error={Boolean(errors?.Cfop_Venda)}
              helperText={errors?.Cfop_Venda}
            />
            </fieldset>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
